import { Button } from "antd";
import { IconDownload } from "@tabler/icons-react";
import downloadCSV from "../utils/downloadCSV";
import dayjs from "dayjs";
import { useState } from "react";
import axios from "axios";
const ExportCSV = ({
  endpoint,
  queryParams,
}: {
  endpoint: string;
  queryParams: string;
}) => {
  const url = `${
    import.meta.env.VITE_APP_API_URL
  }/${endpoint}?export=true&${queryParams}`;
  const [loading, setLoading] = useState(false);
  const getCSVFile = async () => {
    try {
      setLoading(true);
      const res = await axios.get(url, { withCredentials: true });
      downloadCSV(
        res.data,
        ["registrations", dayjs().format("YYYY_MM_DD__HH_mm_ss")].join("__"),
      );
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      icon={<IconDownload size={18} />}
      loading={loading}
      onClick={() => getCSVFile()}
    >
      Export
    </Button>
  );
};

export default ExportCSV;
